import React, { useState } from "react";

import { Modal, Alert, DatePicker } from "antd";
import api from "../../../services/api";

export const RelatorioPrestacaoContas = ({ history }) => {
  const { RangePicker } = DatePicker;
  const [datesAcordo, setDatesAcordo] = useState(null);
  const [datesPagamento, setDatesPagamento] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const handleOk = () => {
    setError(null);
    setLoading(true);

    api
      .get("/acordo/report_prestacao_de_contas/", {
        params: {
          data_acordo__gte: datesAcordo
            ? datesAcordo.initial.format("YYYY-MM-DD")
            : null,
          data_acordo__lte: datesAcordo
            ? datesAcordo.final.format("YYYY-MM-DD")
            : null,
          data_pagamento__gte: datesPagamento
            ? datesPagamento.initial.format("YYYY-MM-DD")
            : null,
          data_pagamento__lte: datesPagamento
            ? datesPagamento.final.format("YYYY-MM-DD")
            : null
        }
      })
      .then(({ data }) => {
        if (!data.link) {
          Modal.error({
            content: "Falha ao obter a url do relatório gerado."
          });
          return;
        }

        const url = data.link;

        Modal.success({
          content: "Relatório gerado com sucesso!"
        });

        window.open(url);
      })
      .catch(err => {
        console.error(err);

        Modal.error({
          content: "Ocorreu um erro ao gerar relatório."
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => history.goBack();

  const handlePagamentoDateChange = value => {
    setError(null);

    if (!value || value.length !== 2) {
      setDatesPagamento(null);
      return;
    }

    const initalDate = value[0];
    const finalDate = value[1];

    if (initalDate.isAfter(finalDate)) {
      return;
    }

    setDatesPagamento({
      initial: initalDate,
      final: finalDate
    });
  };

  const handleAcordoDateChange = value => {
    setError(null);

    if (!value || value.length !== 2) {
      setDatesAcordo(null);
      return;
    }

    const initalDate = value[0];
    const finalDate = value[1];

    if (initalDate.isAfter(finalDate)) {
      return;
    }

    setDatesAcordo({
      initial: initalDate,
      final: finalDate
    });
  };

  return (
    <Modal
      title="Relatório de Prestação de Contas"
      visible
      onOk={handleOk}
      cancelText="Cancelar"
      onCancel={handleCancel}
      okText="Gerar"
      confirmLoading={isLoading}
    >
      <strong>Selecione as datas e clique em "Gerar"</strong>
      <br />
      <span>* Filtro por data do Acordo.</span>

      <div
        style={{
          marginTop: "15px"
        }}
      >
        {error && (
          <div
            style={{
              margin: "8px 0px 8px 0px"
            }}
          >
            <Alert message={error} type="error" />
          </div>
        )}
        <RangePicker
          onChange={handleAcordoDateChange}
          format={"DD/MM/YYYY"}
          placeholder={["Data de cadastro mínima", "Data de cadastro máxima"]}
          value={datesAcordo ? [datesAcordo.initial, datesAcordo.final] : null}
          style={{
            width: "100%"
          }}
        />
      </div>
      <div style={{ marginTop: "15px" }}>
        <span>* Filtro por data de Pagamento.</span>
        <RangePicker
          onChange={handlePagamentoDateChange}
          format={"DD/MM/YYYY"}
          placeholder={["Data de pgto. mínima", "Data de pgto. máxima"]}
          value={
            datesPagamento
              ? [datesPagamento.initial, datesPagamento.final]
              : null
          }
          style={{
            width: "100%",
            marginTop: "8px"
          }}
        />
      </div>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Relatorios/PrestacaoContas/index.jsx